import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.ArchiveFilters;

// initial state
// object name must match specification name
const filters = {
};

if (filterObj && filterObj.find(x => x.Specification === 'PublishAfter')) {
    // add date range filter
    filters.PublishAfter = new FormControl.FilterGroup('PublishAfter', 'Published After', null, null, true, false, 'date');
    filters.PublishBefore = new FormControl.FilterGroup('PublishBefore', 'Published Before', null, null, true, false, 'date');
}

FormControl.assignFilters(filterObj, filters);

export { filters as default };